import { Routes, Route } from "react-router-dom";
import PrivacyPolicy from "./PrivacyPolicy";
import DynamicForm from "./DynamicForm";

function App() {
  return (
    <Routes>
      <Route path="/privacy-policy/:company" element={<PrivacyPolicy />} />

      {/* Dynamic Form Route */}
      <Route path="/form/:company/:type/:comId" element={<DynamicForm />} />

      {/* Fallback */}
      <Route path="*" element={<PrivacyPolicy />} />
    </Routes>
  );
}

export default App;